<template>
  <RegionRetailAnalytics />
</template>

<script>
import RegionRetailAnalytics from "@/components/analytics/RegionRetailAnalytics";

export default {
  components: {
    RegionRetailAnalytics,
  },
};
</script>
